<div style="position: relative;">
    <img [src]="reclFormImg64Seled" alt="Form Image" width="100%" height="100%">


    
</div>
